import { render, staticRenderFns } from "./common-service-img.vue?vue&type=template&id=24b092fe&scoped=true&"
import script from "./common-service-img.vue?vue&type=script&lang=js&"
export * from "./common-service-img.vue?vue&type=script&lang=js&"
import style0 from "./common-service-img.vue?vue&type=style&index=0&id=24b092fe&lang=scss&scoped=true&"
import style1 from "./common-service-img.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b092fe",
  null
  
)

export default component.exports